module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel md-scrollbar md-theme-default",
    attrs: {
      "id": "actions"
    }
  }, [_c('md-content', {
    staticClass: "md-layout-row md-gutter md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('module-menu'), _c('div', {
    staticClass: "md-flex",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('md-table', {
    attrs: {
      "md-theme": "white"
    }
  }, _vm._l((_vm.actions), function(action) {
    return _c('md-table-row', {
      key: action.id,
      class: (_vm.$route.params.action_code && _vm.$route.params.action_code == action.code) ? 'action-row hovered' : 'action-row'
    }, [_c('md-table-cell', {
      staticClass: "load"
    }, [_c('router-link', {
      staticClass: "small md-primary",
      attrs: {
        "to": {
          name: 'Action',
          params: {
            code: _vm.$route.params.code,
            action_code: action.code
          },
          query: _vm.$route.query
        }
      }
    }, [_c('span', {
      staticClass: "md-layout-row md-gutter"
    }, [_c('span', {
      staticClass: "md-flex name"
    }, [_vm._v(_vm._s(action.name + ' (' + action.code + ')'))])])])], 1)], 1)
  }))], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d307368","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/module/views/Actions.vue
// module id = 1132
// module chunks = 0